export function format(first: string, middle: string, last: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export function getDataFromPropString(parsedString: string) {
  if (parsedString) {
    try {
      return JSON.parse(parsedString);
    } catch (e) {
      console.log(e);
      if (parsedString.split(',').length > 0) {
        return parsedString.split(',');
      }
    }
  }
}

export function isWhiteBackground(color: string) {
  return !color || color?.length === 0 || color === 'white' || color === 'fff' || color === 'ffffff';
}

export const isNullOrUndefined = (...values) => {
  return values.every(value => {
    return value === null || value === undefined;
  });
};

export const isNaN = value => {
  if ('isNaN' in Number) {
    return Number.isNaN(value);
  }

  return typeof value === 'number' && value !== value;
};

export function isDirRtl() {
  return document.querySelector('html').dir === 'rtl';
}

export const toKebabCase = string => {
  return string
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();
};

export const lockScroll = (lockStatus: boolean) => {
  switch (lockStatus) {
    case true:
      document.body.style.overflow = 'hidden';
      break;
    case false:
      document.body.style.overflow = '';
      break;
    default:
      document.body.style.overflow = '';
  }
};

export const setImgAltText = (altText: string) => {
  return altText?.length && altText?.toLowerCase() !== 'na' ? altText : '';
};

export const initImageIntersectionObserver = (): void => {
  let lazyImages: NodeListOf<HTMLImageElement> = document.querySelectorAll('.vs-img-lazy');
  // START GENAI@CHATGPT4
  if ('IntersectionObserver' in window) {
    let lazyImageObserver = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry: IntersectionObserverEntry) => {
        if (entry.isIntersecting) {
          let lazyImage: HTMLImageElement = entry.target as HTMLImageElement;
          if (lazyImage.dataset.src) {
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.removeAttribute('data-src');
            lazyImageObserver.unobserve(lazyImage);
          }
        }
      });
    });

    Array.from(lazyImages).forEach((lazyImage: HTMLImageElement) => {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    // Fallback for browsers that do not support IntersectionObserver
    Array.from(lazyImages).forEach((lazyImage: HTMLImageElement) => {
      if (lazyImage.dataset.src) {
        lazyImage.src = lazyImage.dataset.src;
        lazyImage.removeAttribute('data-src');
      }
    });
  }
  // END GENAI@CHATGPT4
};

export const generateRandomId = () => {
  const crypto = window.crypto;
  const array = new Uint32Array(1);
  const uniqueNumArr = crypto.getRandomValues(array);
  return uniqueNumArr[0];
};

 export function debounce(func: (...args: any[]) => void, wait: number) {
  let timeout: number;
  return (...args: any[]) => {
    clearTimeout(timeout);
    timeout = window.setTimeout(() => func(...args), wait);
  };
}

// Function to find object by key and value
export const getObjectByValue = (data: { [key: string]: any }, key: string, value: string) => {
  return Object.values(data).find(item => item[key] == value);
};
